import { request } from "@/utils/request"

export function getApiUrlList(params) {
  return request({
    url: '/appeditor/apiurl/list',
    method: 'get',
    params
  })
}

export function saveApiUrl(data) {
  return request({
    url: '/appeditor/apiurl/save',
    method: 'post',
    data
  })
}

export function deleteApiUrlByIds(ids) {
  return request({
    url: '/appeditor/apiurl/remove',
    method: 'post',
    data: ids
  })
}